/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from "react";
import {useStateContext} from "../utils/web3";
import {Alert, Snackbar} from "@mui/material";

enum Actions {
  START = 1,
  APPROVE_KEY,
  APPROVE_HELL,
  SEND_TO_PORTAL,
}

class ActionManager {

  public static getNextAction(action: Actions): Actions {
    switch (action) {
      case Actions.START:
        return Actions.APPROVE_KEY
      case Actions.APPROVE_KEY:
        return Actions.APPROVE_HELL
      case Actions.APPROVE_HELL:
        return Actions.SEND_TO_PORTAL
    }
    return Actions.START;
  }

  public static getTextSize(action: Actions): string {
    switch (action) {
      case Actions.SEND_TO_PORTAL:
        return "text-2xl md:text-2xl"
    }
    return "text-1xl md:text-1xl";
  }

  public static getText(action: Actions): string {
    switch (action) {
      case Actions.START:
        return "Loading..."
      case Actions.APPROVE_KEY:
        return "Approve the Keys to send them through the portal"
      case Actions.APPROVE_HELL:
        return "Approve the Hell Ducks to send them through the portal"
      case Actions.SEND_TO_PORTAL:
        return "OPEN GATE"
    }
  }
}

function ButtonSocial(props: any) {
  const {
    selectedHellduck,
    selectedDemon,
    selectedSecondduck,
    hellducks,
    secondDucks,
    setHellducks,
    setSecondDucks,
  } = props;
  const [sended, setSended] = useState<any>(false);
  const [loading, setLoading] = useState<any>(false);
  const [action, setAction] = useState<Actions>(Actions.START);
  // Snackbar
  const [snackBarMessage, setSnackBarMessage] = useState<any>('');
  const [isSnackBarOpen, setIsSnackBarOpen] = useState<any>(false);
  const [snackBarSeverity, setSnackBarSeverity] = useState<any>('');

  const { sendThroughPortal, setHellApproval, setKeyApproval, isHellApproved, isKeyApproved } = useStateContext();

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setIsSnackBarOpen(false);
  };

  useEffect(() => {

    const stateMachine = async () => {
      if (action === Actions.START) {
        setLoading(true);
        setAction(Actions.APPROVE_KEY);
        return;
      }

      if(action === Actions.APPROVE_KEY) {
        if(!await isKeyApproved()) {
          setLoading(false);
        } else {
          setAction(Actions.APPROVE_HELL);
        }
        return;
      }

      if(action === Actions.APPROVE_HELL) {
        if(!await isHellApproved()) {
          setLoading(false);
          return;
        } else {
          setAction(Actions.SEND_TO_PORTAL);
        }
      }

      if(action === Actions.SEND_TO_PORTAL) {
        setLoading(false);
      }
    }

    stateMachine().then(console.log);
  }, [ action ]);

  const sendAction = async () => {
    if (loading) return;
    setLoading(true);
    let res = undefined;
    let actionMessage = '';
    try{
      if(action === Actions.APPROVE_KEY) {
        actionMessage = 'sending approve Key transaction';
        res = await setKeyApproval();
        setAction(Actions.APPROVE_HELL);
      }
      if(action === Actions.APPROVE_HELL) {
        actionMessage = 'sending approve Hell transaction';
        res = await setHellApproval();
        setAction(Actions.SEND_TO_PORTAL);
      }
      if(action === Actions.SEND_TO_PORTAL) {
        actionMessage = 'sending ducks through portal';
        res = await sendThroughPortal(
            selectedDemon.token_id,
            selectedHellduck.token_id,
            selectedSecondduck.token_id
        );
      }

    } catch(e) {
      console.log("error");
      setIsSnackBarOpen(true);
      setSnackBarSeverity('error')
      setSnackBarMessage("Error " + actionMessage)
    }
    setLoading(false);
    console.log(res);
    if(res) {
      setIsSnackBarOpen(true);
      setSnackBarSeverity('success')
      setSnackBarMessage("Success " + actionMessage)

    }
    if(action === Actions.SEND_TO_PORTAL) {
      if (res) {
        setSended(true);
        setSecondDucks(
          secondDucks.filter((duck:any) => duck.token_id !== selectedSecondduck.token_id)
        )
        setHellducks(
          hellducks.filter((duck:any) => duck.token_id !== selectedHellduck.token_id && duck.token_id !== selectedDemon.token_id)
        )
      }
    }
  }
  return (
    <div className="flex flex-col items-center p-10">
      {
        sended ? 
        <div className="m-auto leading-normal text-center uppercase txt-primary text-4xl md:text-2xl mb-2">
          Congratulations! <br>
          </br>Transaction sended 
        </div>
        :
        <>
          <div className="flex flex-row justify-around w-full">
            <div className="flex flex-col items-center justify-center">
              <div className="m-auto leading-normal uppercase txt-primary text-3xl md:text-2xl mb-2">
                The duck you will burn (#{selectedHellduck.token_id})
              </div>
              <img src={selectedHellduck.image_url} alt="" className={`rounded-lg resize w-4/5 md:w-3/5`}/>
            </div>
            <div className="flex flex-col items-center">
              <div className="m-auto leading-normal uppercase txt-primary text-3xl md:text-2xl mb-2">
                The duck you will change (#{selectedDemon.token_id})
              </div>
              <img src={selectedDemon.image_url} alt="" className={`rounded-lg resize w-4/5 md:w-3/5`}/>
            </div>
          </div>
          <div className="mt-10 flex flex-row justify-between w-full">
            <div className="flex flex-col items-center justify-center">
              <div className="m-auto leading-normal uppercase txt-primary text-3xl md:text-2xl">
                Key #{selectedSecondduck.token_id}
              </div>
              <div className="normal-text m-auto leading-normal uppercase txt-white text-1xl md:text-1xl mb-2">
                Type: {selectedSecondduck.traits[0].value}
              </div>
              <img
                  src={selectedSecondduck.image_original_url}
                  alt=""
                  className={`rounded-lg resize w-2/5 md:w-3/5`}
                  style={{maxWidth: "300px"}}
              />
            </div>
            <div className="flex flex-col items-center justify-end">
              <button onClick={sendAction} className="flex red-button-bg rounded-lg px-6 md:px-16 py-5">
                {
                  loading ?
                      <div className="lds-default">
                        <div/><div/><div/><div/><div/><div/><div/><div/><div/><div/><div/><div/>
                      </div>
                      :
                      <div
                          className={`m-auto leading-normal uppercase txt-white ${ActionManager.getTextSize(action)} normal-text`}
                      >
                        {ActionManager.getText(action)}
                      </div>
                }
              </button>
            </div>
          </div>
          <Snackbar
              open={isSnackBarOpen}
              autoHideDuration={6000}
              onClose={handleClose}
          >
            <Alert severity={snackBarSeverity} sx={{ width: '100%' }}>
              {snackBarMessage}
            </Alert>
          </Snackbar>
        </>

      }
    </div>
  );
}

export default ButtonSocial;